export class EmailAttachmentRawDto {
    fileName: string;
    fileBase64String: string;
    fileId: number;
    communityId: number;
    customerId: string;
    templateId: number;
    emailCacheId: number;
    mode: 'LOCAL' | 'COMMUNITY' | 'OWNER' | 'TEMPLATE' | 'EMAILATTACHMENT';
}
